/* ==========================================================================
   Bedrock — Grille bento (bdr-media-grid)
   Façade vidéo : n'injecte l'iframe YouTube/Vimeo qu'au clic.
   ========================================================================== */

(function () {
  'use strict';

  class BdrMediaGrid extends HTMLElement {
    connectedCallback() {
      this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    handleClick(event) {
      const button = event.target.closest('[data-bdr-facade-btn]');
      if (!button) return;

      const facade = button.closest('[data-bdr-embed-src]');
      if (!facade) return;

      this.playFacade(facade);
    }

    playFacade(facade) {
      const src = facade.getAttribute('data-bdr-embed-src');
      if (!src) return;

      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = this.dataset.playerTitle || '';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
      iframe.allowFullscreen = true;
      iframe.setAttribute('frameborder', '0');

      facade.innerHTML = '';
      facade.appendChild(iframe);
    }
  }

  if (!customElements.get('bdr-media-grid')) {
    customElements.define('bdr-media-grid', BdrMediaGrid);
  }
})();
